(function () {
  if (window.jrbImpactBannerLoaded) {
    return;
  }

  window.jrbImpactBannerLoaded = true;

  var selector = '[data-impact-fit-text]';
  var frame = null;

  function fitHeading(heading) {
    heading.style.removeProperty('font-size');

    var width = heading.clientWidth;
    if (!width) {
      return;
    }

    var style = window.getComputedStyle(heading);
    var size = parseFloat(style.fontSize);
    if (!size) {
      return;
    }

    var minimum = Math.max(8, size * 0.42);
    heading.style.fontSize = size + 'px';

    while (heading.scrollWidth > width && size > minimum) {
      size -= 0.5;
      heading.style.fontSize = size + 'px';
    }
  }

  function fitAllHeadings() {
    document.querySelectorAll(selector).forEach(fitHeading);
  }

  function scheduleFit() {
    if (frame) {
      window.cancelAnimationFrame(frame);
    }

    frame = window.requestAnimationFrame(function () {
      frame = window.requestAnimationFrame(function () {
        frame = null;
        fitAllHeadings();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFit);
  } else {
    scheduleFit();
  }

  window.addEventListener('resize', scheduleFit, { passive: true });
  document.addEventListener('shopify:section:load', scheduleFit);
  document.addEventListener('shopify:section:select', scheduleFit);
  document.addEventListener('shopify:block:select', scheduleFit);
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-jrb-grid-tab]')) {
      window.setTimeout(scheduleFit, 80);
    }
  });
})();
